<template>
	<div>
		<div v-if="activities.length">
			<v-row justify="start">
				<v-col cols="12" class="py-0 mb-2" v-for="(item, i) in items" :key="i">
					<v-card elevation="3" outlined flat max-width="600">
						<v-card-title class="my-0 py-0" :class="['mdi ' + iconActivity(item.type)]">
							<span class="text--secondary caption pl-2"
								>{{ formatDate(item.date) }}
							</span>
						</v-card-title>
						<v-card-text class="text--secondary text-left py-0 my-0">
							<div v-if="item.type === 'add-work-order'">
								<span class="d-block mx-2 py-1 rounded caption font-weight-bold">
									Orden de Trabajo creada
								</span>
								<span>
									N° OT: {{ formatWorkOrders(item).id }} <br />
									Creada el:
									{{ formatDate(formatWorkOrders(item).date) }}
									<br />

									<v-btn target="_blank" :href="generateWorkOrderLink(item)"
										>Ver OT</v-btn
									>
								</span>
							</div>
							<div v-if="item.type === 'Creado'">
								<span class="d-block mx-2 py-1 rounded caption font-weight-bold">
									Actividad creada {{ item.data.start }} al {{ item.data.end }}
								</span>
								<span>
									{{ item.data.place }}
									<br />
								</span>
							</div>
							<div v-if="item.type === 'Actualizado'">
								<span class="d-block mx-2 py-1 rounded caption font-weight-bold">
									Actividad modificada {{ item.data.start }} al
									{{ item.data.end }}
								</span>
								<span>
									{{ item.data.place }}
								</span>
							</div>
							<div v-if="item.type === 'SMS enviado'">
								<span class="d-block mx-2 py-1 rounded caption font-weight-bold">
									Solicitud de confirmación
								</span>
								<span>
									Administrador solicitó confirmación vía
									{{ item.data.userNotifications.type === 'gps' ? 'GPS' : 'SMS' }}
									en {{ item.data.place }}
									<br />
									Actividad del {{ item.data.start }} al {{ item.data.end }}
								</span>
							</div>
							<div v-if="item.type === 'validationGps'">
								<span>
									<span
										class="d-block mx-2 py-1 rounded caption font-weight-bold"
									>
										Confirmación de ubicación
									</span>
									<span>
										Valido su ubicación y se encuentra
										<strong>
											{{
												item.data.userNotifications.state == 1
													? 'dentro'
													: 'fuera'
											}}
										</strong>
										del establecimiento de servicio
										<br />
										Actividad del {{ item.data.start }} al
										{{ item.data.end }}
									</span>
								</span>
							</div>
							<div v-if="item.type === 'validationSms'">
								<span class="d-block mx-2 py-1 rounded caption font-weight-bold">
									Confirmación de una actividad
								</span>
								<span>
									{{
										item.data.userNotifications.state == 1
											? 'Acepto confirmación de actividad'
											: 'Rechazo confirmación de actividad'
									}}
									del {{ item.data.start }} al {{ item.data.end }}
								</span>
							</div>
							<div v-if="item.type === 'Eliminado'">
								<span class="d-block mx-2 py-1 rounded caption font-weight-bold">
									Actividad eliminada
								</span>
								<span>
									{{ item.data.place }}
									{{ item.data.start }} al
									{{ item.data.end }}
								</span>
							</div>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</div>
		<empty v-else title="Vacío" msj="Sin informacion" class="mt-4" />
		<!-- <v-pagination
			v-if="activities.length"
			v-model="currentPage"
			:length="Math.ceil(activities.length / 10)"
			:total-visible="5"
			@input="paginate"
		></v-pagination> -->
	</div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
	components: {
		Empty: () => import('@/components/ui/DataEmpty'),
	},
	props: {
		activities: {
			type: Array,
			default: () => [],
		},
		formatDate: {
			type: Function,
			required: true,
		},
	},
	computed: {
		items() {
			return this.activities.filter(el => moment(el.date).isSame(this.month, 'month'));
		},
		...mapGetters({
			month: 'Lodging/month',
		}),
	},
	methods: {
		iconActivity(type) {
			if (type === 'Creado') return 'mdi-calendar';
			else if (type === 'Actualizado') return 'mdi-calendar-sync';
			else if (type === 'Eliminado') return 'mdi-calendar-remove';
			else if (type === 'SMS enviado') return 'mdi-gesture-tap';
			else if (type === 'Position') return 'mdi-map-marker-check';
			else if (type === 'validationGps') return 'mdi-map-marker-check';
			else if (type === 'validationSms') return 'mdi-cellphone-message';
			else if (type === 'add-work-order') return 'mdi-file-document-outline';
		},
		formatWorkOrders(workOrder) {
			const index = Math.max(
				...Object.keys(workOrder.data).map(i => (!isNaN(i) ? Number(i) : 0))
			);
			if (Array.isArray(workOrder.data[index])) {
				return {
					id: workOrder.data[index][0],
					date: workOrder.data[index][1],
					type: workOrder.data[index][workOrder.data[index].length - 1],
					lodgingId: workOrder.data[index][workOrder.data[index].length - 2],
					index,
				};
			}
			return workOrder.data[index];
		},
		generateWorkOrderLink(workOrder) {
			const formatedWorkOrder = this.formatWorkOrders(workOrder);
			return `#/${formatedWorkOrder.type}/${formatedWorkOrder.lodgingId}/work-order/${formatedWorkOrder.index}/`;
		},
	},
};
</script>

<style scoped>
span {
	font-size: 10px;
}
</style>
